import { ConditionPreset } from "../../../../../models/Entities";
import { RELATIVE_DATE_CONDITION_OPERATORS } from "../constants";

export const isDefaultFilter = (
  conditionPreset: Partial<ConditionPreset>,
  remoteConditionPresets: ConditionPreset[],
) => {
  // We know a condition preset is a default filter when it exists in the remote, when the operator is a relative date operator, and the value is empty in the remote
  // Currently, all default filters are modified_at filters with relative date operators, this might change in the future which would incur a change here
  const remoteMatch = remoteConditionPresets.find(
    (remoteConditionPreset) =>
      remoteConditionPreset.common_model === conditionPreset.common_model &&
      remoteConditionPreset.operator === conditionPreset.operator &&
      remoteConditionPreset.value === conditionPreset.value,
  );
  const isRelativeDate =
    conditionPreset.operator &&
    RELATIVE_DATE_CONDITION_OPERATORS.includes(conditionPreset.operator);
  const isEmptyValue = !conditionPreset.value;
  return remoteMatch && isRelativeDate && isEmptyValue;
};

/**
 * Normalize a condition preset value for the publish payload.
 *
 * A boolean `false` is a valid filter value and must survive to the request body.
 * A plain `value || null` drops it to null (the classic JS falsy trap), which the
 * backend then rejects because value and operator must both be populated or both null.
 */
export const normalizeConditionPresetValue = (
  value: string | boolean | null | undefined,
): string | boolean | null => (typeof value === "boolean" ? value : value || null);
